import styled from 'styled-components';
import { FlexContainer as Container } from '@taxdown/piccolo-web';
import { Lottie } from 'Components/UI';
import { pxToRem } from 'Styles/utils/utils';
import { MOBILE_WIDTH } from 'Styles/variables/sizes';

export const LottieContainer = styled(Lottie)`
  width: 100%;
  max-width: ${pxToRem(300)};
`;

export const ContentContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FlexContainer = styled(Container)`
  max-width: 564px;
  margin-top: 50px;
  margin-bottom: 50px;
  @media screen and (max-width: ${MOBILE_WIDTH}) {
    align-items: center;
  }
`;

export const Terms = styled.span`
  font-weight: bold;
`;
